<template>
  <div style="display: none;">
    <!-- This component doesn't render anything visible -->
  </div>
</template>

<script>
/* global google */
export default {
  name: 'HotelMapMarker',
  props: {
    hotel: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    priceRange: {
      type: Object,
      default: () => ({ min: 0, max: 1000 })
    }
  },
  data() {
    return {
      marker: null
    };
  },
  mounted() {
    this.createMarker();
  },
  beforeDestroy() {
    this.removeMarker();
  },
  watch: {
    map(newMap, oldMap) {
      if (newMap && newMap !== oldMap) {
        // Map has changed, recreate marker
        this.removeMarker();
        this.$nextTick(() => {
          this.createMarker();
        });
      }
    }
  },
  methods: {
    async createMarker() {
      if (!window.google || !this.hotel.coordinates || !this.map) {
        console.log('Cannot create marker: missing dependencies', {
          google: !!window.google,
          coordinates: !!this.hotel.coordinates,
          map: !!this.map
        });
        return;
      }

      // Remove existing marker if any
      this.removeMarker();

      try {
        await window.google.maps.importLibrary("marker");

        this.marker = new google.maps.Marker({
          position: {
            lat: this.hotel.coordinates.latitude,
            lng: this.hotel.coordinates.longitude
          },
          map: this.map,
          title: this.hotel.hotelName,
          icon: this.getMarkerIcon(this.hotel.cheapestPrice)
        });

        // Add click listener
        this.marker.addListener('click', () => {
          this.$emit('marker-clicked', this.marker, this.hotel);
        });

        //console.log(`Marker created for hotel: ${this.hotel.hotelName}`);
      } catch (error) {
        console.error('Error creating marker:', error);
      }
    },
    
    getMarkerIcon(price) {
      // Color code markers by price range
      //let backgroundColor = '#4285f4'; // Default blue
      let backgroundColor = '#a4393a'; // Gant Red
      let textColor = '#ffffff'; // White text for contrast
      
      /*
      if (this.priceRange) {
        const priceRange = this.priceRange.max - this.priceRange.min;
        const pricePosition = (price - this.priceRange.min) / priceRange;
        
        if (pricePosition < 0.33) {
          backgroundColor = '#34a853'; // Green for low prices
        } else if (pricePosition < 0.66) {
          backgroundColor = '#fbbc04'; // Yellow for medium prices
          textColor = '#000000'; // Black text for better contrast on yellow
        } else {
          backgroundColor = '#ea4335'; // Red for high prices
        }
      }

      */

      // Format price for display (remove decimals if whole number)
      const displayPrice = price % 1 === 0 ? `${price}` : `${price.toFixed(0)}`;
      
      // Calculate text size based on price length
      const fontSize = displayPrice.length <= 4 ? '12' : displayPrice.length <= 5 ? '10' : '9';
      
      return {
        url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
          <svg width="60" height="40" viewBox="0 0 60 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <!-- Price container background (above the pointer) -->
            <rect x="2" y="2" width="56" height="26" rx="13" fill="${backgroundColor}" stroke="#ffffff" stroke-width="0"/>
            <!-- Price text -->
            <text x="30" y="19" text-anchor="middle" fill="${textColor}" font-family="Arial, sans-serif" font-size="${fontSize}" font-weight="bold">${'$' + displayPrice}</text>
            <!-- Pointer/tail flipped 180 degrees (now pointing downward from bottom of container) -->
            <path d="M25 28 L35 28 L30 38 Z" fill="${backgroundColor}" stroke="#ffffff" stroke-width="0"/>
          </svg>
        `)}`,
        scaledSize: new google.maps.Size(60, 40),
        anchor: new google.maps.Point(30, 38)
      };

    },
    
    removeMarker() {
      if (this.marker) {
        this.marker.setMap(null);
        this.marker = null;
      }
    },
    
    getMarker() {
      return this.marker;
    },
    
    getPosition() {
      return this.marker ? this.marker.getPosition() : null;
    }
  }
};
</script>